<template>
  <v-row>
    <v-col sm="12" md="10" lg="10">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="wrapperMask">
          <label class="titleForm"><translate>Email</translate></label>
          <v-text-field
            v-model="formData.email"
            :rules="[emailCheck]"
            :error-messages="emailRule"
            outlined
            required
          ></v-text-field>
          <label class="titleForm"><translate>Password</translate></label>
          <v-text-field
            v-model="formData.password"
            :rules="passwordRules"
            :type="showInput ? 'text' : 'password'"
            :append-icon="showInput ? 'fal fa-eye' : 'fal fa-eye-slash'"
            @click:append="showInput = !showInput"
            outlined
            required
          ></v-text-field>
          <label class="titleForm"
            ><translate>Confirm password</translate></label
          >
          <v-text-field
            v-model="confirmPassword"
            :rules="[confirmPasswordCheck]"
            :type="showInput ? 'text' : 'password'"
            :append-icon="showInput ? 'fal fa-eye' : 'fal fa-eye-slash'"
            @click:append="showInput = !showInput"
            outlined
            required
          ></v-text-field>

          <v-checkbox
            v-model="checkbox"
            :rules="emptyRules"
            class="mt-0 pt-0 pb-4 checkbox-confirm"
            hide-details
          >
            <template v-slot:label>
              <div style="display: inline-block !important">
                <translate class="mr-1">By pressing Register, you agree to our</translate>
                <router-link :to="{ name: 'terms' }" v-translate>Terms and Conditions</router-link>
                <translate class="mr-1">, our</translate>
                <router-link :to="{ name: 'rgpd' }" v-translate>Data Use Policy</router-link>
                <translate class="mx-1">and our</translate>
                <router-link :to="{ name: 'legal' }" v-translate>Cookie Policy</router-link>
              </div>
            </template>
          </v-checkbox>
        </div>
        <v-btn
          color="primary"
          depressed
          @click="increateStep"
          class="text-none font-weight-bold"
        >
          <translate>Register</translate>
          <v-icon size="20" class="pl-3">fal fa-arrow-right-long</v-icon>
        </v-btn>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import Vue from 'vue';
export default {
  name: "FormRegistMember",
  data: () => ({
    valid: true,
    emptyRules: [
      (v) => !!v || Vue.prototype.$gettext("Field is required"),
      // v => (v && v.length <= 10) || 'Field must be less than 10 characters',
    ],
    passwordRules: [
      (v) => !!v || Vue.prototype.$gettext("Field is required"),
      (v) => (v && v.length >= 6) || Vue.prototype.$gettext("Field must be more than 6 characters"),
    ],
    confirmPassword: "",
    emailRule: "",
    showInput: false,
    checkbox: false,
  }),
  computed: {
    emailExists() {
      return this.$store.state.stepper.emailExists;
    },
    formData() {
      return this.$store.state.stepper.formRegistMember;
    },
  },
  watch: {
    emailExists(val) {
      this.emailRule = val ? "" : this.$gettext("E-mail already exists");
      // console.log(this.emailRule);
    },
  },
  methods: {
    openWindow: function (link) {
      window.open(link);
    },
    emailCheck(v) {
      if (v.length) {
        if (/.+@.+\..+/.test(v)) {
          this.$store.dispatch("stepper/emailExists", v);
          this.emailRule = "";
          return true;
        } else {
          this.emailRule = this.$gettext("E-mail must be valid");
          return this.emailRule;
        }
      } else {
        this.emailRule = this.$gettext("E-mail is required");
        return this.emailRule;
      }
    },
    confirmPasswordCheck(v) {
      if (v.length) {
        if (this.formData.password === v) {
          return true;
        } else {
          return this.$gettext("Confirm password do not match");
        }
      } else {
        return this.$gettext("Confirm password required");
      }
    },
    increateStep() {
      if (this.$refs.form.validate() && !this.emailRule) {
        this.$store.commit("stepper/increate");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.checkbox-confirm .v-input__slot {
  align-items: inherit;
}
.checkbox-confirm div {
  font-style: italic;
  font-family: Segoe UI;
  font-weight: 300;
  font-size: 15px;
  color: #000000;
}
</style>
